import * as React from 'react'
import Error from '../components/Error'
import { ForbiddenIllustration } from '../components/Illustrations'
import type { Customization } from '../types/Customization'

const title = 'Access Denied'
const defaultSolutionName = 'the solution owner'

type AccessDeniedProps = {
  customization?: Customization
}

const getText = ({ customization }: AccessDeniedProps) => (
  <p>
    Your access has been denied.
    <br />
    Please contact{' '}
    {!!customization?.enrollmentHomeUrl && !!customization?.enrollmentTeamName ? (
      <a href={customization.enrollmentHomeUrl}>{customization.enrollmentTeamName}</a>
    ) : (
      defaultSolutionName
    )}{' '}
    for further information.
  </p>
)

const AccessDenied = ({ customization }: AccessDeniedProps): JSX.Element => (
  <Error icon={<ForbiddenIllustration />} title={title} text={getText({ customization })} />
)

export default AccessDenied
